module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point2_3-b4119f25ccec2d301355de2141e3c90c.jpg";